const storage = window.localStorage

function getItem<T>(key: string): T | null {
  const item = storage.getItem(key)
  return item ? JSON.parse(item) : null
}

function setItem<T>(key: string, value: T): void {
  storage.setItem(key, JSON.stringify(value))
}

export const useStorage = () => ({
  getItem,
  setItem
}) 